import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ArrowUpRight } from "lucide-react";
import Logo from "@/components/brand/Logo";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useAuth, homeFor } from "@/context/AuthContext";

const LINKS = [
  { to: "/#how", label: "How it works" },
  { to: "/#report", label: "The report" },
  { to: "/#pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function AuthActions({ onNavigate }) {
  const { user } = useAuth();
  if (user) {
    return (
      <Link to={homeFor(user)} onClick={onNavigate} data-testid="header-dashboard-link" className="btn-pill inline-flex items-center gap-1.5 bg-[#4F0341] text-white hover:bg-[#721862]">
        Open dashboard <ArrowUpRight className="h-4 w-4" />
      </Link>
    );
  }
  return (
    <div className="flex items-center gap-2">
      <Link to="/login" onClick={onNavigate} data-testid="header-login-link" className="btn-pill inline-flex items-center text-[#1C111A] hover:bg-[#F3E8F1]">Sign in</Link>
      <Link to="/signup" onClick={onNavigate} data-testid="header-signup-link" className="btn-pill inline-flex items-center bg-[#4F0341] text-white hover:bg-[#721862]">Get started</Link>
    </div>
  );
}

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-ds-cream border-b border-ds-plum/10" data-testid="public-header">
      <div className="container-x h-[72px] flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-[15px] font-medium text-ds-ink hover:text-ds-plum link-underline">
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block"><AuthActions /></div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden p-2 rounded-full hover:bg-[#F3E8F1]" data-testid="mobile-menu-button" aria-label="Open menu"><Menu className="h-6 w-6" /></button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-ds-cream w-[85vw] sm:max-w-sm">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-10 flex flex-col gap-1">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-3 text-lg font-display font-bold border-b border-[#E9DFE7]" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</Link>
              ))}
              <div className="mt-6"><AuthActions onNavigate={() => setOpen(false)} /></div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
